module.exports = "https://web-assets.ifttt.com/packs/media/fonts/avenir_next-bold-fcccb93f.woff2";